import * as React from 'react';
import StarIcon from '@mui/icons-material/Star';
import { useCommonStyles } from '../common';

const CustomRating = (props: any) => {
    const classes = useCommonStyles();
    const { rating } = props;
    return (
        <span className={classes.ratingDiv}>
            <span>{rating}</span>
            <StarIcon style={{ marginTop: '-2px', fontSize: '1rem'}} /> 
        </span>
    )
}

export default CustomRating;
